const API_URL = 'https://presidev.onrender.com/api/'// 'http://localhost:8000/api/'
const API_VERSION = 'v1'
const API_ENDPOINT = API_URL + API_VERSION

export {
  API_ENDPOINT,
  API_URL
}